import Service from './Service'
import { ME } from './apiUrls'

export default class CurrentUserService extends Service {
  getOne () {
    return this.axios.get(ME)
  }
  patch (data) {
    return this.axios.patch(ME, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/CurrentUserService.js